import type { Common } from '../common.js';
import type { PermissionRole } from '../models/flow/permissions.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/permissions/roles';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(): Promise<{ roles: PermissionRole[] }> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.getJSON(url);
  }
}
